import {useQuery} from '@vue/apollo-composable';
import {computed} from 'vue';
import type {Ref} from 'vue';
import type {Menu, MenuItem} from '../index';
import {useSofieConfig} from './config';

export function useSofieMenus() {
  const config = useSofieConfig();
  const query = useQuery<{ menus: Menu[] }>(gql(config.queries.menus));

  return {
    ...query,
    menus: computed<Record<string, Menu>>(() => Object.fromEntries(
      query.result.value?.menus?.map(menu => [menu.name, menu.items]) ?? [],
    )),
  };
}

export function useSofieMenu(name: string | Ref<string>) {
  const config = useSofieConfig();
  const query = useQuery<{ menu: Menu }>(gql(config.queries.menu), {
    name,
  });

  return {
    ...query,
    menu: computed<MenuItem[]>(() => query.result.value?.menu?.items ?? []),
  };
}
